import { createElement } from "./_dom";
import { getApiConfig } from "./context";

function createDropdownItems(el) {
	const cell = el.parentNode;
	const id = parseInt(cell.id.substring(2), 10);
	const appUrl = getApiConfig("appUrl");
	const back = getApiConfig("thisUrl");

	const columns = [
		{ url: `${appUrl}/setup/columnformadd.aspx?column=${id}&back=${back}`, name: 'Add a column before this one' },
		{ url: `${appUrl}/setup/columnformadd.aspx?column=${id}&after=1&back=${back}`, name: 'Add a column after this one' },
		{ url: `${appUrl}/setup/columnformremove.aspx?column=${id}&back=${back}`, name: 'Remove this column from the form' },
		{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&back=${back}`, name: 'Edit the column\'s form properties' },
		{ url: `${appUrl}/setup/columnedit.aspx?column=${id}&back=${back}`, name: 'Edit the column\'s properties' },
		{
			name: 'Lay out row in 1 column',
			additional: [
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1000&back=${back}`, name: '██' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=2000&back=${back}`, name: '████' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=3000&back=${back}`, name: '██████' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=4000&back=${back}`, name: '████████' },
			]
		},
		{
			name: 'Lay out row in 2 columns',
			additional: [
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1100&back=${back}`, name: '██ ██' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1200&back=${back}`, name: '██ ████' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=2100&back=${back}`, name: '████ ██' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=2200&back=${back}`, name: '████ ████' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1300&back=${back}`, name: '██ ██████' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=3100&back=${back}`, name: '██████ ██' },
			]
		},
		{
			name: 'Lay out row in 3 columns',
			additional: [
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1110&back=${back}`, name: '██ ██ ██' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=2110&back=${back}`, name: '████ ██ ██' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1210&back=${back}`, name: '██ ████ ██' },
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1120&back=${back}`, name: '██ ██ ████' },
			]
		},
		{
			name: 'Lay out row in 4 columns',
			additional: [
				{ url: `${appUrl}/setup/columnformprop.aspx?column=${id}&layout=1111&back=${back}`, name: '██ ██ ██ ██' },
			]
		},
		{ url: `${appUrl}/setup/formorder.aspx?table=${getApiConfig("currentTableId")}&back=${back}`, name: 'Reorder columns' },
	];

	return columns.map((column, index) => {
			const link = createElement('a', {
					id: `setup-link-${index}`,
					class: [ 'v3-menu__item', column.additional && 'js-auto-popup v3-popup-trigger'],
					href: column.url ? column.url : '#',
					tabindex: '-1',
					role: 'menuitem',
					'aria-haspopup': column.additional ? "true" : false,
					'aria-controls': column.additional ? `setup-dropdown-${index}` : null
				},
				column.name
			);
			const li = createElement('li', { class: 'v3-menu__cell', role: "none" }, link);
			if (column.additional) {
				link.dataset.popperPlacement = "right-start right-end left-start left-end bottom top";

				const items = column.additional.map((additionalColumn, idx) =>
					createElement('li', {
							class: "v3-menu__cell"
						},
						createElement('a', {
							class: "v3-menu__item",
							href: `${additionalColumn.url}`,
							tabindex: '-1',
							role: 'menuitem',
							id: `setup-link-${idx}`,
							},
							additionalColumn.name)));
				const subMenu = createElement('ul', {
						id: `setup-dropdown-${index}`,
						class: 'v3-popup v3-menu',
						role: 'menu'
					},
					...items);
				li.append(subMenu);
			}
			return li;
		});
}

function showDropdown(dt) {
	let dropdown = document.getElementById('td-gridsetup');
	if (!dropdown) {
		dropdown = createElement('div', {
				id: 'td-gridsetup',
				class: 'v3-formsetup'
			},
			createElement('a', {
				id: 'td-setupgear',
				href: '#',
				class: 'v3-formsetup__gear ui-icon-setup ui-icon-only js-auto-popup',
				'aria-haspopup': 'true',
				'aria-controls': 'td-setupdropdown',
				tabindex: '-1',
				role: 'menuitem',
				"data-popper-placement": "right-start"
				},
				createElement("span", { class: "ui-icontext" }, "Show form setup menu")),
			createElement('ul', {
				id: 'td-setupdropdown',
				class: 'v3-formsetup__menu v3-menu v3-popup',
				role: 'menu',
				},
				...createDropdownItems(dt))
		);
		dt.append(dropdown);
	}
}

function hideDropdown() {
	const dropdown = document.getElementById('td-gridsetup');
	dropdown?.remove();
}

function init(context, selector = 'form.fs-setup>section>div.ui-gridlayout') {
	const form = context.querySelector(selector);

	const columnLabelSelector = 'dl[id^="f_"][id$="_label"]>dt';

	form?.addEventListener('click', ({ target }) => {
		const gear = document.getElementById('td-gridsetup');
		if (gear && !target.contains(gear) && !target.closest("#td-gridsetup,#td-setupdropdown")) {
			hideDropdown();
		}
		const dt = target.closest(columnLabelSelector);
		if (dt && !dt.closest('.ui-icon-formhelp')) {
			showDropdown(dt);
		} else {
			hideDropdown();
		}
	});
}

export { init };